// Imports
import { useDispatch, useSelector } from 'react-redux';
import { getVendorLoginStatus, setVendorHubs, setVendorLoginToken, setVendorProfile } from "../features/vendorProfile";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from './nav/Navbar';
import LoginComponent from './auth/Login';
import { Fragment, useEffect, useState } from 'react';
import { getAuthCookie } from './auth/AuthUtil';
import { GobikesApi } from '../config/Apis';
import { FullScreenLoader } from "./elements/Loaders";
import Bookings from './bookings/BookingsDashboard';
import './App.css';
import { setHubSelection } from '../features/hubSelection';
import { Inventory } from './inventory/BikeDashboard';
import { ManageBlocks } from './blocks/ManageBlocks';
import { AccessoryDashboard } from './accessories/AccessoryDashboard';
import { OfferDashboard } from './offers/OfferDashboard';
import { ProfilePage } from './profile/Profile';
import { Ledger } from './ledger/Ledger';
import { ReviewDashboard } from './reviews/ReviewDashboard';
import { TicketDashboard } from './tickets/TicketDashboard';
import { Homepage } from "./homepage/Homepage";
import { MainDashboardNew } from './dashboard/MainDashboardNew';
import { useMediaQuery, useTheme } from '@mui/material';

// Constants
const drawerWidth = 260;

// Main app component
function App() {

  // Local state
  const [loading, setLoading] = useState(true);

  // Global state
  const loginStatus = useSelector(getVendorLoginStatus);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isPhone = !useMediaQuery(theme.breakpoints.up('md'));

  // Run only once on startup, check token and validate login
  useEffect(() => {
    const authCookie = getAuthCookie();
    if (!authCookie) {
      setLoading(false);
      return;
    }
    setLoading(true);
    (async () => {
      try {
        const { data } = await GobikesApi.get('/vendors/profile-hubs', { params: { cashfreeDetails: true }, headers: { 'vendor-token': authCookie } });
        dispatch(setVendorProfile(data.data.profile));
        dispatch(setVendorHubs(data.data.hubs));
        dispatch(setHubSelection(data.data.hubs[0]));
        dispatch(setVendorLoginToken(authCookie));
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log('Token expired!')
      }
    })();
  }, [dispatch, loginStatus]);

  // If loading state, do no show anything
  let appContent;
  if (loading) {
    appContent = <FullScreenLoader />;
  }

  // Render dashboard if logged in
  else if (loginStatus) {
    appContent = (
      <Fragment>
        <BrowserRouter>
          <Navbar drawerWidth={drawerWidth} />
          <Routes>
            {isPhone ? (
              <Route path='/' element={<Homepage drawerWidth={drawerWidth} />} />
            ) : (
              <Route path='/' element={<MainDashboardNew drawerWidth={drawerWidth} />} />
            )}
            <Route path='/dashboard' element={<MainDashboardNew drawerWidth={drawerWidth} />} />
            <Route path='/bookings' element={<Bookings drawerWidth={drawerWidth} />} />
            <Route path='/reviews' element={<ReviewDashboard drawerWidth={drawerWidth} />} />
            <Route path='/tickets' element={<TicketDashboard drawerWidth={drawerWidth} />} />
            <Route path='/bikes' element={<Inventory drawerWidth={drawerWidth} />} />
            <Route path='/accessories' element={<AccessoryDashboard drawerWidth={drawerWidth} />} />
            <Route path='/blocks' element={<ManageBlocks drawerWidth={drawerWidth} />} />
            <Route path='/ledger' element={<Ledger drawerWidth={drawerWidth} />} />
            <Route path='/offers' element={<OfferDashboard drawerWidth={drawerWidth} />} />
            <Route path='/profile' element={<ProfilePage drawerWidth={drawerWidth} />} />

          </Routes >
        </BrowserRouter >
      </Fragment >
    )
  }

  // Show login screen if not logged in
  else {
    appContent = <LoginComponent />;
  }

  // Render app
  return (
    <div className="App">
      {appContent}
    </div>
  );
}

export default App;
